/* rastah-collgift-ui v8
   Storefront UI for the Collection / Spend gift offers.
   Bar on collection pages, compact card in cart drawer / cart page,
   or anywhere via {% render 'rastah-collgift-slot' %}.

   v8 - collection host detection made resilient. Tapestries runs on
   the collection.pdp template, which stacks price_drop_grid,
   image-hero-with-countdown-pdp and main-collection-product-grid.
   querySelector('[data-section-type="collection"]') returned the
   FIRST such node, which on that template is not the product grid,
   so the bar had no valid anchor and silently rendered nowhere. Now
   every candidate is walked and the first VISIBLE one that actually
   contains a product grid wins. If nothing qualifies, a console
   warning says so instead of failing quietly.

   v7 carried over: no currency conversion - min_spend is authored in
   the customer's currency and compared directly to the cart. */
(function () {
  'use strict';

  var CFG = 'script[data-rastah-collgift-config]';
  var PROP = '_rastah_gwp';
  var CLASS = 'rastah-collgift-block';
  var STYLE_ID = 'rastah-collgift-css';
  var DRAWER = '#shopify-section-quick-cart';
  var TTL = 600000, PAGES = 20;
  var members = {}, rendering = false, timer = null, warned = false;
  var CUR = null;

  function minFor(o) { return o.min_spend || 0; }
  function stalled(h) { return !!(window.__rastahCollStalled && window.__rastahCollStalled[h]); }

  function offers() {
    var el = document.querySelector(CFG);
    if (!el) return [];
    try { return JSON.parse(el.textContent) || []; } catch (e) { return []; }
  }
  function blocked(h) { return (window.__rastahCollBlocked || []).indexOf(h) !== -1; }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function injectCSS() {
    if (document.getElementById(STYLE_ID)) return;
    var css = ''
      + '.rastah-collgift-block{margin:10px 0;padding:11px 13px;border:1px solid var(--cgb-border,#ececec);border-radius:6px;background:var(--cgb-bg,#fff);color:var(--cgb-text,#1a1a1a);font-size:12px;line-height:1.4}'
      + '#shopify-section-quick-cart .rastah-collgift-block{margin:10px 12px}'
      + '.rastah-collgift-block[data-cg-place="cart_page"],.rastah-collgift-block[data-cg-place="slot"]{max-width:620px;margin-left:auto;margin-right:auto}'
      + '.rastah-collgift-block__label{display:block;font-size:9px;letter-spacing:.14em;text-transform:uppercase;opacity:.55;margin:0 0 5px}'
      + '.rastah-collgift-block__heading{margin:0;font-size:12px;font-weight:600}'
      + '.rastah-collgift-block__sub{margin:2px 0 9px;opacity:.6;font-size:11px}'
      + '.rastah-collgift-block__track{position:relative;height:2px;border-radius:2px;background:rgba(0,0,0,.09);overflow:hidden;margin:0 0 10px}'
      + '.rastah-collgift-block__fill{position:absolute;inset:0 auto 0 0;width:0;background:var(--cgb-btn,#1a1a1a);transition:width .45s ease}'
      + '.rastah-collgift-block__row{display:flex;align-items:center;gap:9px}'
      + '.rastah-collgift-block__thumb{flex:0 0 auto;width:36px;height:36px;border-radius:4px;overflow:hidden;display:block}'
      + '.rastah-collgift-block__thumb img{width:100%;height:100%;object-fit:cover;display:block}'
      + '.rastah-collgift-block__info{min-width:0;flex:1}'
      + '.rastah-collgift-block__title{display:block;font-size:11.5px;color:var(--cgb-text,#1a1a1a);text-decoration:none;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}'
      + '.rastah-collgift-block__was{opacity:.45;text-decoration:line-through;margin-right:5px;font-size:11px}'
      + '.rastah-collgift-block__free{font-size:11px;font-weight:600;letter-spacing:.04em}'
      + '.rastah-collgift-block__cta{flex:0 0 auto;background:none;border:none;padding:0;cursor:pointer;color:var(--cgb-text,#1a1a1a);font-size:10px;letter-spacing:.1em;text-transform:uppercase;text-decoration:underline;text-underline-offset:3px}'
      + '.rastah-collgift-block__cta[disabled]{opacity:.5;cursor:wait}'
      + '.rastah-collgift-block__unlocked{font-size:12px;font-weight:600;margin:0 0 9px}'
      + '.rastah-collgift-block,.rastah-collgift-block__cta{font-family:inherit}'
      + '.rastah-collgift-bar{position:relative;display:block;width:100%;margin:0 0 18px;padding:0;border-top:1px solid var(--cgb-border,#ececec);border-bottom:1px solid var(--cgb-border,#ececec);background:var(--cgb-bg,transparent);color:var(--cgb-text,#1a1a1a);font-family:inherit}'
      + '.rastah-collgift-bar__in{display:flex;align-items:center;justify-content:center;flex-wrap:wrap;gap:6px 14px;padding:12px 20px}'
      + '.rastah-collgift-bar__label{font-size:9px;letter-spacing:.16em;text-transform:uppercase;opacity:.5}'
      + '.rastah-collgift-bar__text{font-size:11.5px;letter-spacing:.02em}'
      + '.rastah-collgift-bar__text b{font-weight:600}'
      + '.rastah-collgift-bar__link{font-size:10px;letter-spacing:.1em;text-transform:uppercase;color:inherit;text-decoration:underline;text-underline-offset:3px;background:none;border:none;padding:0;cursor:pointer}'
      + '.rastah-collgift-bar__rule{position:absolute;left:0;right:0;bottom:-1px;height:1px;overflow:hidden}'
      + '.rastah-collgift-bar__fill{display:block;height:100%;width:0;background:var(--cgb-btn,#1a1a1a);transition:width .5s ease}'
      + '@media (max-width:749px){.rastah-collgift-bar__in{padding:10px 16px;gap:4px 10px}.rastah-collgift-bar__text{font-size:11px}}';
    var tag = document.createElement('style');
    tag.id = STYLE_ID;
    tag.textContent = css;
    document.head.appendChild(tag);
  }

  function getCart() {
    var c = window.__rastahGwpCart, now = Date.now();
    if (c && c.p && (now - c.t) < 500) return c.p;
    var p = fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
    window.__rastahGwpCart = { t: now, p: p };
    return p;
  }

  function mkey(h) { return 'rastah_coll_members_' + h; }
  function cached(h) {
    var shared = window.__rastahCollMembers && window.__rastahCollMembers[h];
    if (shared && (Date.now() - shared.t) < TTL) return shared.set;
    var m = members[h];
    if (m && (Date.now() - m.t) < TTL) return m.set;
    try {
      var raw = sessionStorage.getItem(mkey(h));
      if (raw) {
        var o = JSON.parse(raw);
        if (o && o.ids && (Date.now() - o.t) < TTL) {
          var s = new Set(o.ids);
          members[h] = { t: o.t, set: s };
          return s;
        }
      }
    } catch (e) {}
    return null;
  }
  function fetchMembers(h) {
    var ids = [], failed = false;
    function pg(p) {
      return fetch('/collections/' + encodeURIComponent(h) + '/products.json?limit=250&page=' + p,
        { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) { failed = true; return { products: [] }; } return r.json(); })
        .then(function (j) {
          var pr = (j && j.products) || [];
          pr.forEach(function (x) { ids.push(x.id); });
          if (pr.length === 250 && p < PAGES) return pg(p + 1);
        })
        .catch(function () { failed = true; });
    }
    return pg(1).then(function () {
      if (failed) return null;
      var t = Date.now();
      members[h] = { t: t, set: new Set(ids) };
      try { sessionStorage.setItem(mkey(h), JSON.stringify({ t: t, ids: ids })); } catch (e) {}
      return members[h].set;
    });
  }
  function ensure(list) {
    var need = {};
    list.forEach(function (o) {
      if (o.whole_store) return;
      (o.collections || []).forEach(function (c) { if (c && c.handle && !cached(c.handle)) need[c.handle] = true; });
    });
    var hs = Object.keys(need);
    if (!hs.length) return Promise.resolve();
    return Promise.all(hs.map(fetchMembers));
  }
  function ready(o) {
    if (o.whole_store) return true;
    var ok = true;
    (o.collections || []).forEach(function (c) { if (!cached(c.handle)) ok = false; });
    return ok;
  }

  function ours(it) { return !!(it.properties && Object.prototype.hasOwnProperty.call(it.properties, PROP)); }
  function spend(o, cart) {
    var t = 0;
    cart.items.forEach(function (it) {
      if (ours(it)) return;
      var amt = (typeof it.final_line_price === 'number') ? it.final_line_price : it.line_price;
      if (o.whole_store) { t += amt; return; }
      var inn = false;
      (o.collections || []).forEach(function (c) {
        if (inn) return;
        var s = cached(c.handle);
        if (s && s.has(it.product_id)) inn = true;
      });
      if (inn) t += amt;
    });
    return t;
  }
  function giftInCart(o, cart) {
    var found = false;
    cart.items.forEach(function (it) {
      if (ours(it) && it.properties[PROP] === o.handle) found = true;
      else if (o.gift && it.product_id === o.gift.id) found = true;
    });
    return found;
  }

  function money(cents) {
    var v = (cents || 0) / 100;
    var cur = CUR || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined,
        { style: 'currency', currency: cur, maximumFractionDigits: 0 }).format(v);
    } catch (e) {
      return cur + ' ' + Math.round(v).toLocaleString();
    }
  }

  function shopUrl(o) {
    if (o.collections && o.collections.length && o.collections[0].url) return o.collections[0].url;
    if (o.collections && o.collections.length) return '/collections/' + o.collections[0].handle;
    return '/collections/all';
  }

  function barHTML(o, st, place) {
    var c = o.colors || {};
    var style = '--cgb-bg:' + (c.bg && c.bg !== '#ffffff' ? c.bg : 'transparent')
      + ';--cgb-border:' + (c.border || '#ececec')
      + ';--cgb-text:' + (c.text || '#1a1a1a') + ';--cgb-btn:' + (c.btn || '#1a1a1a') + ';';
    var goal = minFor(o), pct, text, link = '';
    var giftName = '<b>' + esc((o.gift && o.gift.title) || 'your free gift') + '</b>';

    if (st.qualifies) {
      pct = 100;
      text = st.giftIn
        ? 'Gift unlocked \u2014 ' + giftName + ' added to your bag, free'
        : 'Gift unlocked \u2014 ' + giftName + ' is yours, free';
      if (!st.giftIn && stalled(o.handle) && o.gift && o.gift.variant) {
        link = '<button type="button" class="rastah-collgift-bar__link" data-cg-add="' + o.gift.variant + '" data-cg-offer="' + esc(o.handle) + '">Add gift</button>';
      }
    } else {
      pct = Math.max(0, Math.min(99, (st.spent / goal) * 100));
      text = (st.spent > 0)
        ? 'You\u2019re ' + esc(money(goal - st.spent)) + ' away from ' + giftName + ', free'
        : 'Spend ' + esc(money(goal)) + ' and receive ' + giftName + ', free';
      link = '<a class="rastah-collgift-bar__link" href="' + esc(shopUrl(o)) + '">' + esc(o.button) + '</a>';
    }

    return '<div class="' + CLASS + ' rastah-collgift-bar" data-gwp-offer="' + esc(o.handle) + '"'
      + ' data-cg-place="' + place + '" data-cg-variant="bar"'
      + ' data-cg-state="' + (st.qualifies ? (st.giftIn ? 'unlocked' : 'pending') : 'progress') + '"'
      + ' style="' + style + '">'
      + '<div class="rastah-collgift-bar__in">'
      + '<span class="rastah-collgift-bar__label">' + esc(o.badge) + '</span>'
      + '<span class="rastah-collgift-bar__text">' + text + '</span>'
      + link
      + '</div>'
      + '<span class="rastah-collgift-bar__rule"><span class="rastah-collgift-bar__fill" style="width:' + pct.toFixed(1) + '%"></span></span>'
      + '</div>';
  }

  function giftRow(o, trailing) {
    var g = o.gift || {};
    return '<div class="rastah-collgift-block__row">'
      + '<a class="rastah-collgift-block__thumb" href="' + esc(g.url) + '"><img src="' + esc(g.image) + '" alt="" loading="lazy"></a>'
      + '<div class="rastah-collgift-block__info">'
      + '<a class="rastah-collgift-block__title" href="' + esc(g.url) + '">' + esc(g.title) + '</a>'
      + '<span class="rastah-collgift-block__was">' + esc(g.was) + '</span><span class="rastah-collgift-block__free">FREE</span>'
      + '</div>' + (trailing || '') + '</div>';
  }

  function cardHTML(o, st, place) {
    var c = o.colors || {};
    var style = '--cgb-bg:' + (c.bg || '#fff') + ';--cgb-border:' + (c.border || '#ececec')
      + ';--cgb-text:' + (c.text || '#1a1a1a') + ';--cgb-btn:' + (c.btn || '#1a1a1a') + ';';
    var inner = '<span class="rastah-collgift-block__label">' + esc(o.badge) + '</span>';

    if (st.qualifies) {
      var msg, trailing = '';
      if (st.giftIn) msg = 'Gift unlocked \u2014 added to your bag';
      else if (stalled(o.handle)) {
        msg = 'Gift unlocked';
        if (o.gift && o.gift.variant) {
          trailing = '<button type="button" class="rastah-collgift-block__cta" data-cg-add="' + o.gift.variant + '" data-cg-offer="' + esc(o.handle) + '">Add gift</button>';
        }
      } else msg = 'Gift unlocked \u2014 adding to your bag\u2026';
      inner += '<p class="rastah-collgift-block__unlocked">' + msg + '</p>' + giftRow(o, trailing);
    } else {
      var goal = minFor(o);
      var left = goal - st.spent;
      var pct = Math.max(0, Math.min(99, (st.spent / goal) * 100));
      var cta = (place !== 'cart_drawer' || st.spent === 0)
        ? '<a class="rastah-collgift-block__cta" href="' + esc(shopUrl(o)) + '">' + esc(o.button) + '</a>' : '';
      inner += '<p class="rastah-collgift-block__heading">' + esc(o.heading) + '</p>'
        + '<p class="rastah-collgift-block__sub">'
        + (st.spent > 0
          ? esc(money(left)) + ' away from your free gift'
          : 'Spend ' + esc(money(goal)) + ' to unlock your free gift')
        + '</p>'
        + '<div class="rastah-collgift-block__track"><span class="rastah-collgift-block__fill" style="width:' + pct.toFixed(1) + '%"></span></div>'
        + giftRow(o, cta);
    }
    return '<div class="' + CLASS + '" data-gwp-offer="' + esc(o.handle) + '" data-cg-place="' + place + '"'
      + ' data-cg-variant="card" data-cg-state="' + (st.qualifies ? (st.giftIn ? 'unlocked' : 'pending') : 'progress') + '"'
      + ' style="' + style + '">' + inner + '</div>';
  }

  function markup(o, st, h) {
    var asBar = (h.place === 'collection_page') || (h.place === 'bar');
    return asBar ? barHTML(o, st, h.place) : cardHTML(o, st, h.place);
  }

  function isCartPage() { return /^\/cart(\/|$|\?)/.test(location.pathname); }
  function isProductPage() { return /\/products\//.test(location.pathname); }
  function collectionHandle() {
    if (isProductPage()) return null;
    var m = location.pathname.match(/\/collections\/([^\/\?]+)/);
    return m ? m[1] : null;
  }
  function hidden(el) {
    var n = el;
    while (n && n.nodeType === 1) {
      if (n.hasAttribute && (n.hasAttribute('hidden') || n.getAttribute('aria-hidden') === 'true')) return true;
      var cs = window.getComputedStyle(n);
      if (cs && (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0)) return true;
      n = n.parentElement;
    }
    return false;
  }
  /* Walk every candidate: templates like collection.pdp stack several
     sections, and the first [data-section-type="collection"] is not
     necessarily the product grid. */
  function collectionAnchor() {
    var inners = document.querySelectorAll('.collection__inner');
    for (var i = 0; i < inners.length; i++) {
      if (!hidden(inners[i])) return inners[i];
    }
    var secs = document.querySelectorAll('[data-section-type="collection"]');
    for (var j = 0; j < secs.length; j++) {
      if (hidden(secs[j])) continue;
      if (secs[j].querySelector('.collection__products, .collection__container, [data-partial]')) return secs[j];
    }
    for (var k = 0; k < secs.length; k++) {
      if (!hidden(secs[k])) return secs[k];
    }
    return null;
  }
  function hosts() {
    var out = [];
    var d = document.querySelector(DRAWER);
    if (d) {
      var panel = d.querySelector('.quick-cart__items') || d.querySelector('[class*="quick-cart__items"]')
        || d.querySelector('.quick-cart__body') || d.querySelector('.quick-cart__inner');
      if (panel && !hidden(panel)) out.push({ el: panel, place: 'cart_drawer', anchor: panel });
    }
    if (isCartPage()) {
      var cp = document.querySelector('#shopify-section-main-cart')
        || document.querySelector('[id^="shopify-section-template--"][id$="__main"]');
      if (cp && !hidden(cp)) out.push({ el: cp, place: 'cart_page', anchor: cp.querySelector('form') || cp.firstElementChild || cp });
    }
    var slots = document.querySelectorAll('[data-rastah-collgift-slot]');
    Array.prototype.forEach.call(slots, function (s) {
      out.push({ el: s, place: s.getAttribute('data-rastah-collgift-slot') || 'slot', anchor: s, slot: true });
    });
    var ch = collectionHandle();
    if (ch && !document.querySelector('[data-rastah-collgift-slot]')) {
      var anchor = collectionAnchor();
      if (anchor) out.push({ el: anchor, place: 'collection_page', anchor: anchor, handle: ch });
      else if (!warned) {
        warned = true;
        console.warn('[rastah-collgift] no visible collection grid found on this template - '
          + 'the bar has nowhere to mount. Add {% render \'rastah-collgift-slot\', place: \'bar\' %} '
          + 'in a Custom Liquid block where you want it.');
      }
    }
    return out;
  }
  function shows(o, h) {
    var locs = o.locations && o.locations.length ? o.locations : ['cart_drawer', 'cart_page'];
    var place = (h.place === 'slot' || h.place === 'bar') ? null : h.place;
    if (place && locs.indexOf(place) === -1) return false;
    if (h.place === 'collection_page' && !o.whole_store) {
      var match = false;
      (o.collections || []).forEach(function (c) { if (c.handle === h.handle) match = true; });
      if (!match) return false;
    }
    return true;
  }

  function render() {
    if (rendering) return;
    var list = offers().filter(function (o) { return o && o.type === 'collection_spend' && !blocked(o.handle); });
    if (!list.length) {
      document.querySelectorAll('.' + CLASS).forEach(function (n) { n.remove(); });
      return;
    }
    rendering = true;
    getCart().then(function (cart) {
      CUR = cart.currency || CUR;
      return ensure(list).then(function () {
        var live = hosts();
        document.querySelectorAll('.' + CLASS).forEach(function (n) {
          var keep = false;
          live.forEach(function (h) { if (h.el.contains(n)) keep = true; });
          if (!keep) n.remove();
        });
        live.forEach(function (h) {
          var html = '';
          list.forEach(function (o) {
            if (!shows(o, h)) return;
            if (!ready(o)) return;
            var sp = spend(o, cart);
            html += markup(o, { spent: sp, qualifies: sp >= minFor(o), giftIn: giftInCart(o, cart) }, h);
          });
          var existing = h.el.querySelectorAll('.' + CLASS);
          var current = '';
          Array.prototype.forEach.call(existing, function (n) { current += n.outerHTML; });
          if (current === html) return;
          Array.prototype.forEach.call(existing, function (n) { n.remove(); });
          if (!html) return;
          var wrap = document.createElement('div');
          wrap.innerHTML = html;
          if (h.slot) {
            while (wrap.firstChild) h.el.appendChild(wrap.firstChild);
          } else {
            var anchor = h.anchor || h.el;
            while (wrap.firstChild) anchor.insertBefore(wrap.firstChild, anchor.firstChild);
          }
        });
      });
    }).catch(function () {}).then(function () { rendering = false; });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-cg-add]') : null;
    if (!btn) return;
    e.preventDefault();
    var variant = parseInt(btn.getAttribute('data-cg-add'), 10);
    var handle = btn.getAttribute('data-cg-offer');
    if (!variant || !handle) return;
    btn.disabled = true;
    var props = {}; props[PROP] = handle;
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variant, quantity: 1, properties: props })
    }).catch(function () {}).then(function () {
      btn.disabled = false;
      window.__rastahGwpCart = null;
      if (window.rastahCollRefreshCart) window.rastahCollRefreshCart();
      render();
    });
  });

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      if (window.requestIdleCallback) window.requestIdleCallback(render, { timeout: 400 });
      else render();
    }, 150);
  }

  function observe() {
    var d = document.querySelector(DRAWER);
    if (d && !d.__cgObserved) {
      d.__cgObserved = true;
      new MutationObserver(schedule).observe(d, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'aria-hidden', 'style'] });
    }
    var a = collectionAnchor();
    if (a && !a.__cgObserved) {
      a.__cgObserved = true;
      new MutationObserver(schedule).observe(a, { childList: true });
    }
  }

  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var _fetch = window.fetch;
  window.fetch = function (input) {
    var url = (typeof input === 'string') ? input : ((input && input.url) || '');
    var p = _fetch.apply(this, arguments);
    if (CART_RE.test(url)) {
      p.then(function (res) { window.__rastahGwpCart = null; schedule(); observe(); return res; }).catch(function () {});
    }
    return p;
  };
  var XO = XMLHttpRequest.prototype.open, XS = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, url) { this.__cgUrl = url || ''; return XO.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    if (CART_RE.test(String(this.__cgUrl || ''))) {
      this.addEventListener('loadend', function () { window.__rastahGwpCart = null; schedule(); observe(); });
    }
    return XS.apply(this, arguments);
  };
  document.addEventListener('rastah-collgift:changed', function () { window.__rastahGwpCart = null; render(); });
  document.addEventListener('cart:updated', schedule);
  document.addEventListener('quick-cart:updated', schedule);
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-js-cart-icon]')) setTimeout(schedule, 120);
  }, true);

  function boot() { injectCSS(); observe(); schedule(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.rastahCollGiftUI = render;
})();
